module.exports = __webpack_public_path__ + "img/home-contacts-noise.png?76cc1634c01d01f192fbb3712e53c059";